module.exports = __webpack_public_path__ + "img/Inhouse ecosystem.e327ecf5.svg";